<template>
  <v-expansion-panels class="panels" :value="0">
    <v-expansion-panel class="panel" v-if="selectedDashboard.hasRaffle">
      <v-expansion-panel-header>Raffle Files</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-layout column>
          <v-flex style>
            <v-row class="optionsBox">
              <v-col v-if="getCampaignId" class="optionsBox">
                <v-autocomplete
                  v-model="selectedCampaignId"
                  :items="selectableCampaigns"
                  item-text="text"
                  item-value="symbol"
                  label="Select Campaign Id"
                >
                </v-autocomplete>
              </v-col>
              <v-col class="optionsBox">
              <v-autocomplete
                v-model="raffleType"
                :items="raffleTypes"
                item-text="name"
                item-value="value"
                label="Select Raffle Type"
              >
              </v-autocomplete>
            </v-col>
                <v-btn
                  class="button"
                  color="blue darken-2"
                  @click="getRaffleFiles()"
                  :disabled="selectedCampaignId == '' || raffleType == ''"
                  >Get Files
                </v-btn>
            </v-row>
            <v-data-table
              v-if="isClick"
              :items="raffleFiles"
              :no-data-text="'Not found'"
              :disable-pagination="true"
              :hide-default-footer="true"
              :headers="headers"
            >
              <template slot="item" slot-scope="{ item }">
                <tr>
                  <td>{{ item.id }}</td>
                  <td>{{ item.fileName }}</td>
                  <td>{{ item.raffleType }}</td>
                  <td>
                      <v-btn
                        class="ma-2"
                        outlined
                        :href='item.path'
                        download>
                        Download XLSX
                    </v-btn>
                  </td>
                </tr>
              </template>
              <template slot="no-data">
                <v-alert
                  :value="true"
                  icon="mdi-cancel"
                  class="display-1 font-weight-thin"
                  >No items found for now ¯\_(ツ)_/¯</v-alert
                >
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-expansion-panel-content>
    </v-expansion-panel>
        <v-expansion-panel class="panel" v-if="selectedDashboard.hasRaffle">
      <v-expansion-panel-header>Upload Winner Users</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-layout column>
          <v-flex style>
            <v-row class="optionsBox">
              <v-col class="dropdown" v-if="getCampaignId">
                <v-autocomplete
                  v-model="selectedCampaignId"
                  :items="selectableCampaigns"
                  item-text="text"
                  item-value="symbol"
                  label="Select Campaign Id"
                >
                </v-autocomplete>
              </v-col>
              <v-col class="dropdown">
                <v-autocomplete
                    v-model="raffleType"
                    :items="raffleTypes"
                    item-text="name"
                    item-value="value"
                    label="Select Raffle Type"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row class="optionsBox">
              <v-col class="dropdown">
                <v-file-input
                  v-model="files"
                  color="green accent-4"
                  counter
                  label=""
                  multiple
                  :disabled="selectedCampaignId == '' || raffleType == ''"
                  placeholder="Select your xlsx files"
                  prepend-icon="mdi-paperclip"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  outlined
                  @change="readExcel"
                  :show-size="1000"
                >
                </v-file-input>
              </v-col>
                <v-col class="searchBox">
                <v-checkbox
                  v-model="sendVoucher"
                  label="Send Voucher"
                ></v-checkbox>
              </v-col>
              <v-col class="searchBox">
                <v-row>
                  <v-btn
                    class="button"
                    color="green darken-2"
                    :disabled="!fileStatus || !sendVoucher"
                    @click="uploadFile()"
                  >
                    <v-icon dark> mdi-cloud-upload </v-icon>
                    Upload File
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="optionsBox">
              <v-col class="dropdown">
                <v-alert
                  v-if="message !== '' && fileStatus"
                  :type="this.messageType"
                >
                  <v-icon v-if="this.messageType === 'success'" dark>
                    mdi-checkbox-marked-circle
                  </v-icon>
                  {{ message }}</v-alert
                >
              </v-col>
            </v-row>
            <v-row class="optionsBox">
            <v-col class="dropdown">
                             <v-data-table
              :items="excelData"
              :no-data-text="'Not found'"
              :disable-pagination="true"
              :hide-default-footer="true"
              :headers="headersReadExcel"
            >
              <template slot="item" slot-scope="{ item }">
                <tr>
                  <td>{{ item.referenceNumber }}</td>
                </tr>
              </template>
            </v-data-table>
            </v-col>
            </v-row>
          </v-flex>
        </v-layout>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel class="panel" v-else>
      <v-expansion-panel-header>Raffle</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-layout column>
          <v-flex style>
            <v-alert
              :value="true"
              icon="mdi-cancel"
              class="display-1 font-weight-thin"
              >Raffle has not yet been added for this campaign.
              ¯\_(ツ)_/¯</v-alert
            >
          </v-flex>
        </v-layout>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import XLSX from "xlsx";

export default {
  data() {
    return {
      fileStatus: false,
      isClick: false,
      raffleFiles: [],
      sendVoucher: false,
      excelData: [],
      files: [],
      itemType: "",
      messageType: "",
      message: "",
      selectedCampaignId: "",
      raffleType: "",
      raffleTypes: [
        { name: "Weekly Raffle", value: "weekly" },
        { name: "Final Raffle", value: "final" }
      ],
      headers: [
        { sortable: false, align: "left", text: "Id" },
        { sortable: false, text: "File Name" },
        { sortable: false, text: "Raffle Type" },
        { sortable: false, text: "Download Excel" }
      ],
      headersReadExcel: [
        { sortable: false, align: "left", text: "Reference Number" }
      ]
    };
  },
  computed: {
    ...mapGetters(["userToken", "selectedDashboard"]),
    getCampaignId: {
      get() {
        if (this.selectedDashboard.campaignId === "pg-template") {
          this.selectableCampaigns = [];
        } else if (this.selectedDashboard.campaignId === "pg-ro") {
          this.selectableCampaigns = [{ text: "pg-charity-ro", value: "" }];
        } else if (this.selectedDashboard.campaignId === "pg-turkey") {
          this.selectableCampaigns = [];
        }
        return true;
      }
    }
  },
  methods: {
    ...mapActions(["getDashboardData", "errorHandler"]),
    readExcel() {
      this.excelData = [];
      this.message = "";
      this.fileStatus = false;
      var input = this.files;
      var reader = new FileReader();
      reader.onload = () => {
        var fileData = reader.result;
        var wb = XLSX.read(fileData, { type: "binary" });
        wb.SheetNames.forEach((sheetName) => {
          var rowObj = XLSX.utils.sheet_to_json(wb.Sheets[sheetName]);
          this.excelData = rowObj; //JSON.stringify(rowObj);
        });
      };
      reader.readAsBinaryString(input[0]);
      this.setData();
    },
    setData() {
      setTimeout(() => {
        this.fileStatus = true;
        let tempArry = this.excelData;
        this.excelData = [];
        var index = 0;
        const lastIndex = tempArry.length;

        for (index = 0; index < lastIndex; index++) {
          const referenceNumber = tempArry[index]["referenceNumber"];
          this.excelData.push({ referenceNumber });
        }
      }, 300);
    },

    getRaffleFiles() {
      const method = "post";
      const url = `${this.selectedDashboard.endPoints.base}/getRaffleFiles`;
      const data = {
        sessid: this.userToken,
        campaignId: this.selectedCampaignId,
        raffleType: this.raffleType
      };
      axios({ method, url, data })
        .then((response) => {
          if (response.data.response) {
            this.isClick = true
            this.raffleFiles = response.data.files;
          } else {
            this.errorHandler(response.data.message || response.data.error)
          }
        })
        .catch((er) => {
          this.errorHandler(er.response);
        });
    },

    uploadFile() {
      const data = {
        sessid: this.userToken,
        winners: JSON.stringify(this.excelData),
        campaignId: this.selectedCampaignId,
        raffleType: this.raffleType
      };
      axios({
        method: "post",
        url: `${this.selectedDashboard.endPoints.base}/uploadWinnerList`,
        data
      })
        .then((response) => {
          if (response.data.response) {
            if (response.data.warning) {
              this.messageType = "warning";
              this.message = response.data.message;
            } else {
              this.messageType = "success";
              this.message = response.data.message;
            }
          } else {
            this.messageType = "error";
            this.message = response.data.message;
          }
        })
        .catch(() => {});
    }
  },
  mounted() {
    if ("name" in this.selectedDashboard === false) {
      const dashboard = JSON.parse(localStorage.selectedDashboard);
      this.$store.commit("setDashboard", dashboard);
    }
    this.$store.commit("setUserRoles", JSON.parse(localStorage.userRoles));
  }
};
</script>

<style scoped>
.optionsBox {
  margin-left: 12px;
  margin-right: 12px;
  margin-top: 12px;
}
.dropdown {
  max-width: 50%;
}
.searchBox {
  max-width: 30%;
  display: flex;
  align-items: center;
}
.panel {
  margin-top: 12px;
}
.panels {
  margin-left: 20px;
  margin-right: 20px;
}
.buttonFooter {
  margin-top: 20px;
  margin-bottom: 20px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.button {
  margin-top: 40px;
  margin-bottom: 20px;
  display: block;
  margin-left: auto;
  margin-right: auto;}
</style>
